export const getDealStatuses = `
  query getDealStatuses {
    dealStatuses {
      value: dealStatusUuid
      label: name
    }
  }
`;

export interface DealStatusOption {
  value: string;
  label: string;
}

export interface GetDealStatusesType {
  dealStatuses: DealStatusOption[];
}
